import { render, staticRenderFns } from "./PickImportAnswersPage.vue?vue&type=template&id=2ee1c8bc&"
import script from "./PickImportAnswersPage.vue?vue&type=script&lang=js&"
export * from "./PickImportAnswersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports